import Typography from "@mui/material/Typography";
import Loading from "../../../../shared/ui/Loading";
import Box from "@mui/material/Box";
import StudentsSelectMultipleClassrooms from "./StudentsSelectMultipleClassrooms";

const CreateTestSelectedClassrooms = ({
                                          loading,
                                          classrooms,
                                          selectedStudents,
                                          setSelectedStudentsHandler,
                                          setTeacherHandler,
                                          errors,
                                          handleTestStartDate,
                                      }: any) => {

    return (
        <>
            <Typography variant="h3" mb={3} mt={3}>
                Alege elevii pentru care dorești generarea testului
            </Typography>
            {loading.loading && loading.name === "students" ? (
                <Loading show={true}/>
            ) : (
                <>
                    {classrooms.map((classroom: any, index: number) => (
                        <Box key={index} mb={1}>
                            <StudentsSelectMultipleClassrooms
                                classroom={classroom}
                                selectedTeacher={classrooms.find((classroomT: any) => classroomT.id === classroom.id)?.teachers.find((teacher: any) => teacher.checked === true)}
                                selectedStudents={selectedStudents}
                                setSelectedStudentsHandler={setSelectedStudentsHandler}
                                setTeacherHandler={setTeacherHandler}
                                errors={errors}
                                handleTestStartDate={handleTestStartDate}
                            />
                        </Box>
                    ))}
                </>
            )}
        </>
    )
}

export default CreateTestSelectedClassrooms;